import { Link } from 'react-router-dom'
import { ChevronLeft, ChevronRight, ListTree } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import type { ReaderBundle } from '@/api/readerApi'
import { Button } from '@/components/ui/button'
import type { ReaderTab } from './ReaderMultimodalTabs'

interface ChapterNavProps {
  projectId: string
  bundle?: ReaderBundle
  onOpenToc: () => void
  currentTab?: ReaderTab
}

export function ChapterNav({ projectId, bundle, onOpenToc, currentTab = 'text' }: ChapterNavProps) {
  const { t } = useTranslation()
  const prev = bundle?.nav.prev_chapter_no ?? null
  const next = bundle?.nav.next_chapter_no ?? null
  const tabHash = `#${currentTab}`

  return (
    <div className="border-t bg-background">
      <div className="mx-auto flex max-w-[38em] items-center justify-between gap-3 px-4 py-4">
        {prev ? (
          <Button asChild variant="outline">
            <Link to={`/projects/${encodeURIComponent(projectId)}/reader/ch/${prev}${tabHash}`}>
              <ChevronLeft className="size-4" />
              <span className="hidden sm:inline">{t('reader.previous')}</span>
            </Link>
          </Button>
        ) : (
          <Button variant="outline" disabled>
            <ChevronLeft className="size-4" />
            <span className="hidden sm:inline">{t('reader.previous')}</span>
          </Button>
        )}

        <Button variant="ghost" onClick={onOpenToc}>
          <ListTree className="size-4" />
          {t('reader.backToToc')}
        </Button>

        {next ? (
          <Button asChild variant="outline">
            <Link to={`/projects/${encodeURIComponent(projectId)}/reader/ch/${next}${tabHash}`}>
              <span className="hidden sm:inline">{t('reader.next')}</span>
              <ChevronRight className="size-4" />
            </Link>
          </Button>
        ) : (
          <Button variant="outline" disabled>
            <span className="hidden sm:inline">{t('reader.next')}</span>
            <ChevronRight className="size-4" />
          </Button>
        )}
      </div>
    </div>
  )
}
